import React from "react";
import { Card } from "../types/SharedTypes";
import { SuitClubIcon, SuitDiamondIcon, SuitHeartIcon, SuitSpadeIcon } from "../assets/icons";

export const getRelativeDate = (dateNumber: number): string => {
  const now = new Date();
  const date = new Date(dateNumber);
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000); // Difference in seconds

  if (diff < 5) {
    return "just now";
  } else if (diff < 60) {
    const seconds = diff;
    return `${seconds}s ago`;
  } else if (diff < 3600) {
    const minutes = Math.floor(diff / 60);
    return `${minutes}m ago`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    return `${hours}h ago`;
  } else if (diff < 2592000) {
    const days = Math.floor(diff / 86400);
    return `${days}d ago`;
  } else {
    return basicDateFormat(dateNumber);
  }
}

export const basicDateFormat = (date: number) => {
  return new Date(date).toLocaleDateString('en-US', { dateStyle: 'medium' });
}

export const getPlayingCardUI = (card: Card | null) => {
  if (!card) return {realRank: "?", realSuit: SuitHeartIcon};

  const {rank, suit} = card;
  
  const realRank = rank === 13 ? "K" : rank === 12 ? "Q" : rank === 11 ? "J" : rank === 1 ? "A" : rank.toString();
  const realSuit = suit === 'h' ? SuitHeartIcon : suit === 'c' ? SuitClubIcon : suit === 'd' ? SuitDiamondIcon : SuitSpadeIcon;
  return {realRank, realSuit};
}

export const createSafeInvalidatex = (invalidate: () => void) => () => {
  invalidate();

  let intervalId: NodeJS.Timer | undefined = undefined;

  let i = 0;
  intervalId = setInterval(() => {
    if (i === 10) clearInterval(intervalId);
    i++;
    invalidate();
  }, 50);
}

//not in docs, but it seems like this is equivalent to above
export const createSafeInvalidate = (invalidate: (frames?: number) => void) => () => {
  invalidate(30);
}